import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, handleUserLevelAccessPermissions, getAllYears, validateRoles, validateMonthYears } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { generateWholesaleHapurReport } from '../ExportPriceWagesExcel';
import { format } from 'date-fns';
import messages from '../.././../../assets/Messages.json';
import priceTitle from '../../../../price.json';

const PriceHapurMandiInputReport = () => {
    const [isDivision, setIsDivision] = useState(false);
    const [years, setYears] = useState([]);
    const [months, setMonth] = useState([]);
    const [yearName, setYearName] = useState('');
    const [startDate, setStartDate] = useState();
    const [monthName, setMonthName] = useState('');
    const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token)
    const navigate = useNavigate();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const [dateSelectedError, setDateSelectedError] = useState(false);


    const getMonthsList = (e) => {
        showLoading(true)
        axios
          .get(`${API_URL}api/graph/getMonths/2019`, config)
          .then((res) => {
            let monthDataResponse = res.data;
            if (monthDataResponse.status) {
              setMonth(monthDataResponse.data);
              showLoading(false)
            }
          })
          .catch((err) => {
            console.error(err);
            showLoading(false);
          });
      }
    
      const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

    useEffect(() => {

        const level = handleUserLevelAccessPermissions(decode_token);
        setButtonAccess(level)

         const getYearList = () => {
            const startYear = 2014; // Starting year
            const endYear = 2024; // Ending year

            const yearsArray = [];
            for (let year = startYear; year <= endYear; year++) {
                yearsArray.push(year);
            }

            setYears(yearsArray);
        };



        const userRole = async () => {
            showLoading(true)
            try {
                const role = await validateRoles(decode_token)
                if (role) {
                   getYearList();
                   getMonthsList(); 
                 } else {

                    alert("You are not an authorized user to capture the data for Pricing");
                    navigate("/dashboard");
                }
                showLoading(false)
            } catch (error) {
                console.log(error);
                showLoading(false)
            }
        }

       userRole();

   }, []);



    const handleGenerateExcel = () => {

        if (!startDate) {
            setDateSelectedError(true);
            toast.error("Please select a date to generate the report.", messages.COLOR_RED);
            return;
        }
       
        const formattedDate = startDate ? format(new Date(startDate), 'dd MMM yyyy').toLowerCase() : '';
        // const formattedMonth = months[new Date(startDate).getMonth()];
        const postData = {
            fromDate: formattedDate, 
        };
        let wholesaleHapurReport='';
       
        showLoading(true)
        // POST request to API
        axios
            .post(`${API_URL}api/price/hapurreport`, postData, config)
            .then((response) => {
           
                  wholesaleHapurReport = response.data.data.GroupCodes;

                let excelFileName = `PriWholesaleHapurReport_${formattedDate}`;

                function getCurrentDateTime() {
                    const now = new Date();
                
                    const month = (now.getMonth() + 1).toString().padStart(2, '0');
                    const day = now.getDate().toString().padStart(2, '0');
                    const year = now.getFullYear();
                    
                    const hours = now.getHours().toString().padStart(2, '0');
                    const minutes = now.getMinutes().toString().padStart(2, '0');
                    const seconds = now.getSeconds().toString().padStart(2, '0');
                
                    return `${month}/${day}/${year}, ${hours}:${minutes}:${seconds}`;
                }
                const excelObjectData = {
                    fileName: excelFileName,
                    reportType: excelFileName,
                    fileType: 'xls',
                    sheetName: "Wholesale Hapur",
                    // firstRowMergeCells: "A1:C1",
                    // firstRowExportDatesss: 'माह  के प्रथम शुक्रवार के भाव ',
                    firstRowExportDate: getCurrentDateTime(),
                    firstRowCellNumber: 12,
                    fromDate: formattedDate,
                    // secondRowMergeCells: "A2:B2",
                    // secondRowText: 'जनपद - कानपुर नगर ',
        
                    // secondRowCellNumber: 11,
                    // thirdRowMergeCells: "A3:G3",
                    // thirdRowText: "General Index Report",
        
                    headerHindiColumns: [
                        'क्रम संख्या',
                        'वस्तु का नाम',
                        'विविधता नाम',
                        'इकाई मात्रा',
                        'औसत  भाव (रू0 में)'
                    ],
                };
             
                const transformedData = wholesaleHapurReport.map((item, index) => [
                    index + 1,
                    item.ItemName,
                    item.varityName,
                    item.ItemUnitName,
                    item.Price,
                ]);
                excelObjectData.excelRowData = transformedData;
                generateWholesaleHapurReport(excelObjectData)




            })
            .catch((error) => {

                console.error('API Error', error);
            })
            .finally(() => {

                showLoading(false)
            })
        
    };


    const filterDate = (date) => {
        return date <= new Date(); // Disable dates after today
    };


    const getCurrentDateTime = () => {
        const currentDateTime = new Date();
        const formattedDateTime = currentDateTime.toLocaleString(); // Adjust format as needed
        return formattedDateTime;
    };


    const storedLanguage = localStorage.getItem('language');
    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                
                                 <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.HAPUR_ITEM_REPORT : priceTitle.en.HAPUR_ITEM_REPORT }} />

                            </h4>

                            <div className="row align-items-center">
                                {isDivision &&
                                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                        <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                                        <input typr="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                                    </div>
                                }

                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
                                    <label className="fw-bold h6">Select Week Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        dateFormat="dd MMM yyyy"
                                        placeholderText="DD MMM YYYY"
                                        selected={startDate}
                                        onChange={(date) => {
                                            setStartDate(date);
                                            setDateSelectedError(false); // Clear error when date is selected
                                        }}
                                        filterDate={filterDate}  // Update startDate state on date selection
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                                            <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                    {"<"}
                                                </button>
                                                <select
                                                    onChange={(e) => {
                                                        setYearName(parseInt(e.target.value)); // Update yearName when changed
                                                        changeYear(parseInt(e.target.value));
                                                    }}
                                                    value={yearName} // Update value to yearName
                                                >
                                                    <option value="" disabled>Select Year</option>
                                                    {years &&
                                                        years.map((ele, index) => (
                                                            <option key={index} value={ele}>
                                                                {ele}
                                                            </option>
                                                        ))}
                                                </select>

                                                <select
                                                    value={date.getMonth()} // Use date.getMonth() instead of monthName
                                                    onChange={(e) => {
                                                        setMonthName(e.target.value); // Update monthName when changed
                                                        changeMonth(e.target.value);
                                                    }}
                                                >
                                                    <option value="" disabled>Select Month</option>
                                                    {months &&
                                                        months
                                                        .filter((_, i) => !(currentYear === yearName && i > currentMonth))
                                                        .map((ele, i) => (
                                                            <option key={i} value={i}>
                                                                {shortMonthToFull(ele.MONTH)}
                                                            </option>
                                                        ))}
                                                </select>

                                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                    {">"}
                                                </button>
                                            </div>
                                        )}
                                    />

                                </div>

                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default PriceHapurMandiInputReport